import React, { Component } from 'react'; // eslint-disable-line
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ManagedInput from './ManagedInput';
import i18n from '../../i18n';

class ValidatedInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFocused: false,
            value: this.props.value,
        };

        this.onBlurFn = this.onBlurFn.bind(this);
        this.onFocusFn = this.onFocusFn.bind(this);
        this.onChangeFn = this.onChangeFn.bind(this);
        this.myInp = React.createRef();
        this.focusTextInput = this.focusTextInput.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== prevProps.value && prevState.value !== this.props.value) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                value: !this.props.value ? '' : this.props.value,
            });
        }
    }

    onBlurFn(e) {
        this.setState({
            isFocused: false,
        });
        if (this.state.value === '' && this.props.menuTitle) {
            this.setState({ value: this.props.value });
        }

        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    onFocusFn(e) {
        this.setState({
            isFocused: true,
        });

        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    onChangeFn(e) {
        this.setState({
            value: e.target.value,
        });

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    focusTextInput() {
        // Explicitly focus the text input using the raw DOM API
        // Note: we're accessing "current" to get the DOM node
        this.myInp.current.focus();
    }

    render() {
        let {
            containerClass,
            containerId,
            actionClass,
            labelText,
            name,
            hasError,
            hasSuccess,
            type,
            onReturnDown,
        } = this.props;

        type = !type ? 'text' : type;

        containerClass = this.state.isFocused ? (`${containerClass} edit-in-focus`) : containerClass;
        if (hasError) {
            containerClass += ' has-error';
        } else if (hasSuccess) {
            containerClass += ' has-success';
        }

        return (
            <div id={containerId} className={containerClass} data-qa={containerId}>
                {labelText?.length > 0 && <label data-qa={`label-for-${this.props.dataqa}`}>{labelText}</label>}
                <ManagedInput
                    type={type}
                    onFocus={this.onFocusFn}
                    onReturnDown={onReturnDown}
                    name={name}
                    value={this.state.value}
                    maxLength={this.props.charLimit}
                    onBlur={this.onBlurFn}
                    onChange={this.onChangeFn}
                    placeholder={this.props.placeholder}
                    autoFocus={false}
                    dataqa={`input-for-${this.props.dataqa}`}
                    refInput={this.myInp}
                    menuTitle={this.props.menuTitle}
                />
                <div className={actionClass} data-qa={`edit-for-${this.props.dataqa}`}>
                    <span>{i18n.t('edit')}</span>
                    <FontAwesomeIcon icon={['fas', 'pencil']} color="#616B7D" onClick={this.focusTextInput} style={{ cursor: 'pointer' }} />
                </div>
            </div>
        );
    }
}

export default ValidatedInput;
